import { connect } from 'react-redux';
import { StoreState } from '../../../reducers';
import DownloadGroupButton, { DownloadGroupButtonStatus } from '../../../components/DriveItem/DownloadGroupButton';
import DownloadManagerUtils from '../../../utils/downloadManager';
import { DownloadGroupStatus } from '../../DownloadManager/reducer';

interface DownloadGroupButtonContainerProps {
	isOnlyImportants?: boolean;
}

const mapStateToProps = (state: StoreState, props: DownloadGroupButtonContainerProps) => {
	const {
		galleryInfos,
		galleryInfos: {
			template: {
				commonStyles: {
					primary: {
						strongColor,
					},
				},
			},
			config: {
				applicationGallery,
				importantAssets,
			},
		},
		downloadManager,
		downloadManager: {
			downloadGroups,
			isDeletingAll,
		},
		driveList
	} = state;
	const { isOnlyImportants } = props;
	const downloadGroup = isOnlyImportants ? downloadGroups.important : downloadGroups.all;
	const { isDownloading, status } = downloadGroup;
	const enabledImportantTags = DownloadManagerUtils.getEnabledImportantTags(importantAssets);
	const importantTagsParam = isOnlyImportants ? enabledImportantTags : [];
	const hasItemsToDownload = DownloadManagerUtils.hasItemsToDownload(downloadManager, driveList, galleryInfos, importantTagsParam);
	const loaderStep = DownloadManagerUtils.getGalleryLoaderStep(downloadManager, driveList, applicationGallery, isDownloading, importantTagsParam);
	const downloadGroupButtonStatus = getDownloadGroupButtonStatus(status, hasItemsToDownload);

	return {
		strongColor,
		isDownloading,
		isDeletingAll,
		loaderStep,
		status: downloadGroupButtonStatus,
	};
};


const getDownloadGroupButtonStatus = (downloadAllStatus: DownloadGroupStatus, hasItemsToDownload: boolean): DownloadGroupButtonStatus => {
	switch (downloadAllStatus) {
		case DownloadGroupStatus.NotStarted:
			return DownloadGroupButtonStatus.Download;
		case DownloadGroupStatus.Started:
			return DownloadGroupButtonStatus.ContinueDownloading;
		case DownloadGroupStatus.Finished:
			return hasItemsToDownload ? DownloadGroupButtonStatus.Update : DownloadGroupButtonStatus.DownloadComplete;
	}
};
export default connect(mapStateToProps)(DownloadGroupButton);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/DriveItem/DownloadGroupButton/index.tsx